import { render, staticRenderFns } from "./cmyk-farben.vue?vue&type=template&id=a26024f0&scoped=true"
import script from "./cmyk-farben.vue?vue&type=script&lang=js"
export * from "./cmyk-farben.vue?vue&type=script&lang=js"
import style0 from "./cmyk-farben.vue?vue&type=style&index=0&id=a26024f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26024f0",
  null
  
)

export default component.exports